import { render, staticRenderFns } from "./handitemwaichu.vue?vue&type=template&id=aa3aa40a"
import script from "./handitemwaichu.vue?vue&type=script&lang=js"
export * from "./handitemwaichu.vue?vue&type=script&lang=js"
import style0 from "./handitemwaichu.vue?vue&type=style&index=0&id=aa3aa40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports